var _style, _g, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKantarMediaLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 242.3 54.5",
    style: {
      enableBackground: "new 0 0 242.3 54.5"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{enable-background:new    ;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.7,33.2h-2.1l-6.1-9.6v14h-3V16.8h2.1l8,12.7l8-12.7h2.1v20.9h-3v-14L146.7,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,25.5v2.8h-6.9v6.6h9.2v2.8h-12.2V16.8h11.9v2.8h-8.9v5.8H171z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.2,37.7V16.8h6.3c3.3,0,5.5,0.7,7.2,2c2.6,1.9,4.2,5,4.2,8.5c0,3.5-1.6,6.6-4.1,8.5c-1.7,1.3-3.9,2-7.2,2H177.2z  M189.3,21.4c-1.3-1.1-3-1.8-6-1.8h-3.1v15.2h3.1c2.9,0,4.6-0.6,6-1.8c1.6-1.4,2.5-3.5,2.5-5.8C191.8,24.9,190.9,22.8,189.3,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.5,16.8h3v20.9h-3V16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.4,32.3h-8.8l-2.2,5.4h-3.1l8.6-20.9h2.1l8.6,20.9h-3.1L218.4,32.3z M210.8,29.5h6.4l-3.2-7.7L210.8,29.5z"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6,37.7l7.6-20.8h3.8l7.6,20.8h-4l-1.8-4.9h-7.5l-1.8,4.9H34.6z M41.8,29.2h4.9l-2.4-6.7L41.8,29.2z M88.6,37.7 l7.6-20.8h3.8l7.6,20.8h-4l-1.8-4.9h-7.5l-1.8,4.9H88.6z M95.8,29.2h4.9l-2.4-6.7L95.8,29.2z M55.6,16.8h3.1l10.7,13.2V16.8h4v20.8 h-2.8L59.7,24.1v13.6h-4V16.8z M90.8,16.8v3.6h-5.5v17.3h-4V20.4h-5.5v-3.6C75.8,16.8,90.8,16.8,90.8,16.8z M127.4,37.7l-6.5-9 c0.8-0.3,1.5-0.8,2-1.3c1-1.1,1.6-2.7,1.6-4.3s-0.6-3.2-1.6-4.3c-1.2-1.2-2.7-1.9-5.4-1.9h-7.8v20.8h4v-8.5h3.3l6.1,8.5L127.4,37.7 L127.4,37.7z M113.7,20.4h3.6c1.4,0,2.1,0.3,2.5,0.8c0.4,0.5,0.7,1.1,0.7,1.8c0,0.7-0.2,1.3-0.7,1.8c-0.5,0.5-1.2,0.8-2.5,0.8h-3.6 V20.4z M33.7,16.8h-4.4l-7.5,10.4l7.5,10.4h4.4l-7.5-10.4L33.7,16.8z M19.5,16.8h-2.7v20.8h2.7V16.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.645,
    y1: 18.2966,
    x2: 20.645,
    y2: 39.1633,
    gradientTransform: "matrix(1 0 0 -1 0 56)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B28300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    style: {
      stopColor: "#BF9512"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4507,
    style: {
      stopColor: "#E2C542"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#FFED6A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7259,
    style: {
      stopColor: "#FBE462"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9011,
    style: {
      stopColor: "#EDC648"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E8BB3E"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 16.8,
    className: "st1",
    width: 2.2,
    height: 20.8
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKantarMediaLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/kantar-media-logo.e249b0755e11a08abb6563ebec8dbc63.svg";